import { ApiResponse, IThemeRes } from 'src/interfaces';

export const mapThemes = (response: ApiResponse): IThemeRes[] => {
  return response?.data.map((theme: IThemeRes) => theme) ?? [];
};
